import { toast } from "react-toastify";
import { getApi, postApi } from "./apis";

const requestCache = new Map();

const cacheKey = (endpoint: string, params?: any) => {
  return `${endpoint}${params ? JSON.stringify(params) : ""}`;
};

const withCache = async (key: string, request: () => Promise<any>) => {
  if (requestCache.has(key)) {
    return requestCache.get(key);
  }

  const promise = request();
  requestCache.set(key, promise);

  try {
    const result = await promise;
    setTimeout(() => requestCache.delete(key), 2000);
    return result;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
};

export const fetchRevenueDropdownData = async (type: string) => {
  let endpoint = "";

  switch (type) {
    case "calendarYear":
      endpoint = "CropYear/Get";
      break;
    case "cropType":
      endpoint = "revenue/crop-types";
      break;
    case "landlord":
      endpoint = "masterdata/farms";
      break;
    case "landlordClientMapping":
      endpoint = "revenue/landlord-client-mappings";
      break;
    default:
      throw new Error("Invalid dropdown type");
  }

  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data for ${type}: ${error.message}`);
      }
      throw new Error(
        `Failed to fetch data for ${type}: unknown error occurred`
      );
    }
  });
};

export const filterRevenueData = async (data: any) => {
  try {
    return await postApi("revenue/filter", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      toast.error("No data please try again");
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      toast.error("No data please try again");
      throw new Error("Failed to fetch data : unknown error occurred");
    }
  }
};

export const updateRevenueShare = async (data: any) => {
  try {
    const response = await postApi("revenue/update", data);
    return response;
  } catch (error: any) {
    if (error?.response) {
      throw new Error(error.response.data);
    }
    throw new Error(`Failed to update revenue data : ${error.message}`);
  }
};